import PageHero from "@/components/sections/PageHero";
import Textile from "@/components/sections/Textile";

export default function TextilePage() {
  return (
    <>
      <PageHero
        eyebrow="/ Textile maison"
        title="Canapés, matelas"
        accent="& mobilier textile"
        description="Nettoyage en profondeur de vos textiles d'intérieur, à domicile. Shampouineuse professionnelle, séchage rapide, résultats visibles."
      />
      <Textile />
    </>
  );
}
